import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { datetime } from "../../../../util/library/datetime";
import { selectVessel } from "../../../../util/store/selectors";
import { SHORT_DATETIME_FORMAT } from "../../../../util/varibles/constants";
import { checkLimit } from "../../../../util/varibles/global";
import { vesselDetailActions } from "../../reducer";
import { handleScrollPointer } from "../../utils";
import { widthMinus } from "./constants";
import styles from "./style.module.scss";

interface IProps {
    loading: boolean
}

const Pointer: React.FC<IProps> = () => {
    const [style, setStyle] = useState()
    const dispatch = useDispatch();
    const currentTime = useSelector(selectVessel.currentTime)
    const finishTime = useSelector(selectVessel.finishTime)
    const isDragging = useSelector(selectVessel.isDragging)
    const rulerEl = useRef<any>(null);
    const relX = useRef(0);
    const position = useRef(0);
    const rootRef = useRef<HTMLDivElement>(null);

    const intervalMove = useRef<any>(null);

    useEffect(() => {
        rulerEl.current = document.getElementById('ruler');

        const handleDragging = (e: any) => {
            const { pageX } = e;
            if (!rulerEl)
                return;
            const { scrollLeft = 0, offsetWidth = 0 } = rulerEl.current || {};
            const newPosition = checkLimit(0, offsetWidth + 45, pageX + relX.current) + 45;
            if (newPosition !== position.current) {
                position.current = newPosition;
                const duration = (offsetWidth + 90 - newPosition - scrollLeft) / (widthMinus * 3) * 3600000;
                dispatch(vesselDetailActions.dragging({ duration: -duration, key: 'finishTime' }))
                window.clearInterval(intervalMove.current);
                const { left: min, right: max } = rulerEl.current?.getBoundingClientRect() || { left: 0, right: 0 };
                intervalMove.current = handleScrollPointer({
                    target: rulerEl, pageX: checkLimit(min, max, pageX), min, max,
                    action: (space: number) => {
                        const duration = space * 3600000 / (widthMinus * 3);
                        dispatch(vesselDetailActions.dragging({ duration, key: 'currentTime' }))
                    },
                    clearInterval: () => window.clearInterval(intervalMove.current)
                });
            }
        }

        const handleDragEnd = () => {
            if (intervalMove)
                clearInterval(intervalMove.current)
            document.removeEventListener('mousemove', handleDragging);
            document.removeEventListener('mouseup', handleDragEnd);
        }

        if (rootRef.current) {
            const handleDragStart = (e: any) => {
                const { pageX, currentTarget } = e;
                relX.current = currentTarget.offsetLeft - pageX;
                document.addEventListener('mousemove', handleDragging);
                document.addEventListener('mouseup', handleDragEnd);
                dispatch(vesselDetailActions.beginDrag())
            }
            rootRef.current.addEventListener('mousedown', handleDragStart);
        }
        return () => {
            document.removeEventListener('mousemove', handleDragging);
            document.removeEventListener('mouseup', handleDragEnd);
            if (intervalMove)
                clearInterval(intervalMove.current);
        }
    }, [dispatch]);

    useEffect(() => {
        const style: any = { transition: isDragging ? '' : 'right 100ms' }
        if (rulerEl.current) {
            const { scrollLeft = 0, offsetWidth = 0 } = rulerEl.current || {};
            const position = (finishTime - currentTime) / 3600000 * widthMinus * 3 + 45 + scrollLeft
            style.right = checkLimit(45, offsetWidth + 45, position) + 'px';
        } else {
            style.right = ((finishTime - currentTime) / 3600000 * widthMinus * 3 + 45) + 'px';
        }
        setStyle(style)
    }, [isDragging, currentTime, finishTime]);



    return <div className={styles.pointer} style={style} ref={rootRef} >
        <span>{datetime(currentTime).format(SHORT_DATETIME_FORMAT)}</span>
    </div>;
};

export default Pointer;